import React, { useEffect, useState } from 'react';
import createTrack from 'services/actions/tracker_actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProportionalSaleTypes } from 'store/modules/proportional_sale_simulation_store/types';
import { getServiceSubscriptionStatus } from 'store/modules/service_subscription_store/actions';
import { ProfileState } from 'store/modules/profile_store/types';
import { monitoringSubscriptionCompany } from 'services/monitoring_companies';
import { getInfoUser } from 'store/modules/my_account_store/actions';
import { ProportionalSale } from 'services/actions/proportional_sale';
import { ServicesSubscriptionState } from 'store/modules/service_subscription_store/types';
import MonitoringPortalsList, {
  FEATURED_PORTAL_IDS,
} from 'components/molecules/monitoring_portals_list';
import Chat from 'assets/images/chat/tela_chat.svg';
import Person from 'assets/images/chat/person.png';
import { videosData } from 'components/atoms/open_tutorial/videos';
import { Container } from './styles';

interface SaleRobo {
  data: {
    valor_final: string | number;
  };
}

const MonitoringSellingPage = () => {
  const [buyNow, setBuyNow] = useState<boolean>(false);
  const [dados, setDados] = useState<SaleRobo>();
  const videoUrl = videosData;

  const dispatch = useDispatch();
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { servicesSubscriptions } = useSelector<ApplicationState, ServicesSubscriptionState>(
    (state) => state.storage.servicesSubscriptions,
  );

  useEffect(() => {
    document.title = 'Monitorar Chat - ConLicitação';
  }, []);

  useEffect(() => {
    dispatch(getInfoUser(profile?.id));
    dispatch(
      getServiceSubscriptionStatus(2, monitoringSubscriptionCompany(profile) || profile.clientId),
    );

    const handleClick = async () => {
      const response = await ProportionalSale(10, [2]);
      if (response?.status === 200) {
        setDados(response.data);
      }
    };

    if (!servicesSubscriptions?.Monitoring?.current_signature && !profile.in_sample) {
      handleClick();
    }
  }, [
    dispatch,
    profile?.currentCompany,
    profile?.id,
    profile?.can_use_my_documents,
    profile?.in_sample,
  ]);

  useEffect(() => {
    dispatch({
      type: ProportionalSaleTypes.DADOS_PROPORTIONAL_SALE,
      dados,
      servico: [2],
    });
  }, [buyNow]);

  return (
    <Container>
      <div className="container position-one">
        <div className="row mb-4 px-md-4 py-0 py-md-4">
          <div className="col-md-6 mt-5">
            <h1 className="font-weight-bold">Monitoramento de Chat</h1>
            <h4 className="mt-3">
              O pregoeiro se comunica pelo chat. Não acompanhar a tempo pode gerar prejuízos, como
              desclassificação, multa e impedimento de licitar.
            </h4>
            <button
              type="button"
              className="btn btn-success button-green"
              onClick={() => {
                createTrack('Contratar - Monitoramento');
                setBuyNow(true);
              }}
            >
              CONTRATE AGORA
            </button>
          </div>
          <div className="col-md-6">
            <iframe
              title="Monitoramento chat"
              id="video"
              width="100%"
              height="295"
              src={videoUrl?.monitoring}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="container-video"
            />
          </div>
        </div>
      </div>
      <div className="bg-img">
        <div className="container">
          <div
            id="conhecer"
            className="row margin session-one mb-5 bg-green py-3 py-md-0 p-md-0 text-white"
          >
            <div className="col-md-12">
              <div className="row align-items-center">
                <div className="col-md-6 order-2 order-md-1">
                  <img src={Chat} alt="Monitoramento chat" width="100%" />
                </div>
                <div className="col-md-6 text order-1 order-md-2">
                  <p className="font-weight-bold mb-2">Não perca nenhuma convocação!</p>
                  <p className="mb-0">
                    Com o Monitorar Chat do ConLicitação, você acompanha chats de pregoeiros em
                    tempo real de mais de 300 portais, garantindo que sua empresa esteja protegida e
                    pronta para responder a tempo.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title font-weight-bold">Alterações de Prazo</h5>
                  <p className="card-text font-weight-light">
                    Agilidade para <br />
                    responder a tempo
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title font-weight-bold">Retomadas de Sessão</h5>
                  <p className="card-text font-weight-light">
                    Mais chances reais de <br />
                    vitória nas disputas
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title font-weight-bold">Decisões sobre recursos</h5>
                  <p className="card-text font-weight-light">
                    Redução de riscos <br /> jurídicos e operacionais
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title font-weight-bold">Convocações inesperadas</h5>
                  <p className="card-text font-weight-light">
                    Segurança para <br /> disputar
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-5">
        <div className="row my-5">
          <div className="col-md-8">
            <h4 className="font-weight-bold my-3">Impulsione seu desempenho nas licitações!</h4>
            <p>✅ Monitore mais de 300 portais oficiais de pregão</p>
            <p>✅ Centralize tudo em um painel organizado e fácil de usar</p>
            <p>✅ Receba alertas automáticos com base em palavras-chave</p>
            <p>✅ Consulte o histórico completo mesmo após o fim da disputa</p>
            <p>✅ Ganhe respaldo jurídico ao demonstrar que estava atento às comunicações</p>
          </div>
          <div className="col-md-4">
            <img src={Person} className="img-person" alt="Person" width="70%" />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className="card bg-white text-dark">
              <div className="card-body">
                <h5 className="card-title font-weight-bold">+290 milhões</h5>
                <p className="card-text font-weight-light">de mensagens captadas</p>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="card bg-white text-dark">
              <div className="card-body">
                <h5 className="card-title font-weight-bold">+380 mil</h5>
                <p className="card-text font-weight-light">licitações monitoradas</p>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="card bg-white text-dark">
              <div className="card-body">
                <h5 className="card-title font-weight-bold">
                  Nenhuma outra tem essa cobertura no Brasil
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-12">
            <h4 className="text-center font-weight-bold mb-4">
              Conheça todos os portais monitorados
            </h4>
            <div className="portals-scroll">
              <MonitoringPortalsList
                imgSize="27px"
                cardSize="col-md-2"
                featuredIds={FEATURED_PORTAL_IDS}
              />
            </div>
          </div>
        </div>
        <div className="row my-5">
          <div className="col-12 my-5 text-center">
            <h3 className="font-weight-bold">
              Ative agora a ferramenta que mais monitora portais <br />
              de licitações no Brasil
            </h3>

            <div className="card card-price bg-white text-center text-dark w-50 mx-auto">
              <p className="text-uppercase fw-bold text-white sale-price-tag p-2">
                APROVEITE O PREÇO PROMOCIONAL
              </p>

              <div className="p-4 d-flex flex-column align-items-center">
                <span>
                  de{' '}
                  <span className="preco-antigo">
                    <del>R$ 159,00</del>
                  </span>{' '}
                  mensais
                </span>

                <span>
                  para <span className="preco-novo">R$ 59,00</span> mensais
                </span>

                <span className="my-4">
                  Valor total{' '}
                  {dados?.data?.valor_final.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}{' '}
                  proporcional ao seu plano atual de assinatura
                </span>

                <button
                  type="button"
                  className="btn btn-sale-page"
                  onClick={() => {
                    createTrack('Contratar - Monitoramento');
                    setBuyNow(true);
                  }}
                >
                  ATIVAR O MONITORAMENTO
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-dark" />
    </Container>
  );
};

export default MonitoringSellingPage;
